/*
Akhila 11/19/2022 2700271704 Created new Component
Sohel 11/22/2022 2700271704 fixed search Table reset Issue
Prakash 11/22/2022 2700271704 Fixed Responsiveness.
Akhila 11/25/2022 2700271704 textField label name, placeholder change
akhila 11/26/2022 2700271704 changed label for code and description
Suresh Peddavoora 11/29/2022 2700271704 Fixed Alignments for TextFields in Tab Responsive.
Suresh Peddavoora 11/30/2022 2700271704 Fixed Responsive Issues for TextFields in Desktop Resolution.
akhila 12/08/2022 2700271704 adding session storage for search items
lalitha 12/09/2022 2700271704 Added Created Date Field
Raghu 12/09/2022 2700271704 Field Responsive Alignment Fixes
Suresh peddavoora 12/20/2022 2700271704 Fixed Textfields alignments
Suresh peddavoora 12/27/2022 2700271704 Fixed Textfields and Button alignments
sai krishna  1/2/2023 2700271704 rename labels
Dilip  02/13/2023 2700271704 created by dropdown changes
Raghu 02/21/2023 2700271704 changed text feilds colors
Raghu 02/28/2023 2700271704 fixed new ui alignments
Prakash 03/28/2023 2700271704 fixed input filed issue.
Akhila 06/08/2023 2699234404 created date change to date created field and column
*/
import React, {useContext, useEffect, useState} from 'react';
import {useForm} from 'react-hook-form';
import {TextField, FormControl, Button, FormHelperText} from '@material-ui/core';
import {Controller} from 'react-hook-form';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import TriggerAccountSearchTable from './TriggerAccountSearchTable';
import {
  fetchCreatedByDropDownData,
  getAllReportCreatedForData,
} from '../../../../redux/reducers/ReportMaster';
import {useDispatch, useSelector} from 'react-redux';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import * as Yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';
import {createdByOptions} from '../../../../util/CreatedByForOptions';
export default function TriggerAccountSearchForm({setValue}) {
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);

  const searchSessionTriggerAccount = JSON.parse(sessionStorage.getItem('SearchTriggerAccount'));
  const initialValues = {
    groupCode: '',
    description: '',
    createdBy: '',
    createdDate: null,
  };
  const validationSchema = Yup.object().shape({
    createdDate: Yup.date().typeError('Invalid date format').nullable(),
  });
  const {
    handleSubmit,
    control,
    reset,
    errors,
    setValue: setFieldValue,
  } = useForm({
    mode: 'all',
    defaultValues: searchSessionTriggerAccount ? searchSessionTriggerAccount : initialValues,
    resolver: yupResolver(validationSchema),
  });
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const onSubmit = (data) => {
    setSearchData(data);
    setSubmit(true);
    sessionStorage.setItem('SearchTriggerAccount', JSON.stringify(data));
  };

  const {createdByData} = useSelector(({reportMaster}) => reportMaster);
  const onClear = () => {
    const data = {
      groupCode: '',
      description: '',
      createdBy: '',
      createdDate: null,
    };
    setSearchData(data);
  };
  useEffect(() => {
    dispatch(getAllReportCreatedForData());
    dispatch(fetchCreatedByDropDownData('accountupdate'));
  }, []);
  return (
    <>
      <h2 className="search-title">Account Update Search</h2>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="form-row new-standard-textfields align-items-center">
          <div className="col-md-4 col-lg-3 col-xl-3 form-group  account-guarantor">
            <FormControl variant="outlined" fullWidth>
              <Controller
                render={({value, onChange}) => (
                  <TextField
                    className={`${classes.labelName}`}
                    placeholder="Enter Account Update Name"
                    margin="dense"
                    name="groupCode"
                    variant="outlined"
                    label="Account Update Name"
                    value={value}
                    onChange={onChange}
                    error={Boolean(errors.groupCode?.message)}
                    fullWidth
                  />
                )}
                control={control}
                name="groupCode"
              />
            </FormControl>
          </div>
          <div className="col-md-4 col-lg-3 col-xl-3 form-group  account-guarantor">
            <FormControl variant="outlined" fullWidth>
              <Controller
                render={({value, onChange}) => (
                  <TextField
                    className={`${classes.labelName}`}
                    placeholder="Enter Account Update  Description"
                    margin="dense"
                    name="description"
                    variant="outlined"
                    label="Account Update  Description"
                    value={value}
                    onChange={onChange}
                    error={Boolean(errors?.description?.message)}
                    fullWidth
                  />
                )}
                control={control}
                name="description"
              />
            </FormControl>
          </div>
          <div className="col-md-4 col-lg-3 col-xl-3 form-group  account-guarantor">
            <Controller
              render={({onChange, value}) => (
                <GuiAutoComplete
                  classes={{
                    option: classes.option,
                  }}
                  id="createdBy"
                  size="small"
                  options={createdByData || []}
                  value={value}
                  getOptionLabel={(option) => {
                    return option && option?.userLoginName ? option?.userLoginName : '';
                  }}
                  renderOption={(option) => {
                    return createdByOptions(option);
                  }}
                  onChange={(e, value) => {
                    // onChange(data);
                    setFieldValue('createdBy', value);
                  }}
                  renderInput={(params) => (
                    <div className="select-field">
                      <GuiTextField
                        {...params}
                        className={`${classes.labelName}`}
                        variant="outlined"
                        margin="dense"
                        label="Created By"
                        placeholder="Select Created By"
                      />
                    </div>
                  )}
                />
              )}
              name="createdBy"
              control={control}
            />
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group  account-guarantor">
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <FormControl variant="outlined" fullWidth>
                <Controller
                  render={({value}) => (
                    <KeyboardDatePicker
                      className={`${classes.labelName}`}
                      orientation="portrait"
                      format="MM/dd/yyyy"
                      value={value}
                      autoOk
                      inputVariant="outlined"
                      margin="dense"
                      placeholder="MM/DD/YYYY"
                      fullWidth
                      label="Date Created"
                      helperText={null}
                      error={Boolean(errors?.createdDate?.message)}
                      onChange={(date) => {
                        setFieldValue('createdDate', date);
                        return {value: date};
                      }}
                    />
                  )}
                  control={control}
                  name="createdDate"
                />
              </FormControl>
            </MuiPickersUtilsProvider>
            <FormHelperText variant="outlined">
              {errors?.createdDate?.message ? errors?.createdDate?.message : ''}
            </FormHelperText>
          </div>
          <div className="col-md-3 col-lg-12 col-xl-12 form-group ">
            <div className="d-flex justify-content-md-start justify-content-lg-center">
              <Button
                type="button"
                onClick={() => {
                  reset(initialValues);
                  onClear();
                  sessionStorage.removeItem('SearchTriggerAccount');
                  setSubmit(true);
                }}
                variant="outlined"
                className={`reset-btn mx-1 ${classes.buttonRoot}`}
              >
                Reset
              </Button>
              <Button
                type="submit"
                variant="outlined"
                className={`search-btn mx-1 ${classes.buttonRoot}`}
              >
                Search
              </Button>
            </div>
          </div>
        </div>
      </form>

      <div>
        <TriggerAccountSearchTable
          searchData={searchData}
          setSearchData={setSearchData}
          submit={submit}
          setSubmit={setSubmit}
          setValue={setValue}
        />
      </div>
    </>
  );
}
